/**
 * @description 门店折扣模块路由
 */

export const storeDiscountRouter = [
  {
    path: '/storeDiscount',
    redirect: '/storeDiscount/list'
  },
  {
    path: '/storeDiscount/list',
    name: 'storeDiscountList',
    component: () => import('views/storeDiscount/list/index.vue'),
    meta: { title: '门店折扣' }
  },
  {
    path: '/storeDiscount/add',
    name: 'storeDiscountAdd',
    component: () => import('views/storeDiscount/add/index.vue'),
    meta: { title: '添加折扣' }
  },
  {
    path: '/storeDiscount/detail',
    name: 'storeDiscountDetail',
    component: () => import('views/storeDiscount/detail/index.vue'),
    meta: { title: '折扣详情' }
  },
  {
    path: '/storeDiscount/stores',
    name: 'storeDiscountStores',
    component: () => import('views/storeDiscount/applicableStores/index.vue'),
    meta: { title: '折扣门店' }
  },
  {
    path: '/storeDiscount/selectStore',
    name: 'storeDiscountSelectStore',
    component: () => import('views/storeDiscount/selectStore/index.vue'),
    meta: { title: '选择门店' }
  }
]
